import React, { memo, useState } from 'react';
import { useFloatingWindowsStore } from '../../../store/floatingWindowsStore';
import {
    unifiedStatsContainer,
    unifiedControlSectionHeader,
    unifiedControlSectionIcon,
    unifiedControlSectionContent,
    unifiedControlGroup,
    unifiedControlButton,
} from '../unifiedPanelStyles';

interface UnifiedStatisticsPanelProps {
    particleStates: any[];
}

const UnifiedStatisticsPanel: React.FC<UnifiedStatisticsPanelProps> = memo(({ particleStates }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    // Use persistent store for window open/close state
    const {
        particleCount,
        energyDistribution,
        velocityHistogram,
        speciesPercentages,
        energyGraph,
        toggleWindow,
    } = useFloatingWindowsStore();

    const windowButtonStyle = (isOpen: boolean): React.CSSProperties => ({
        ...unifiedControlButton,
        background: isOpen ? 'rgba(79, 195, 247, 0.3)' : 'rgba(60, 150, 60, 0.8)',
        border: isOpen ? '2px solid #4fc3f7' : '1px solid #44aa44',
    });

    return (
        <div style={unifiedStatsContainer}>
            <button
                style={unifiedControlSectionHeader}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <span style={unifiedControlSectionIcon}>
                    {isExpanded ? '▼' : '▶'}
                </span>
                Statistics
            </button>

            {isExpanded && (
                <div style={unifiedControlSectionContent}>
                    <div style={unifiedControlGroup}>
                        <button
                            style={windowButtonStyle(particleCount)}
                            onClick={() => toggleWindow('particleCount')}
                        >
                            📊 Particle Count {particleCount ? '(Open)' : ''}
                        </button>

                        <button
                            style={windowButtonStyle(energyDistribution)}
                            onClick={() => toggleWindow('energyDistribution')}
                        >
                            ⚡ Energy Distribution {energyDistribution ? '(Open)' : ''}
                        </button>

                        <button
                            style={windowButtonStyle(velocityHistogram)}
                            onClick={() => toggleWindow('velocityHistogram')}
                        >
                            🎯 Velocity Histogram {velocityHistogram ? '(Open)' : ''}
                        </button>

                        <button
                            style={windowButtonStyle(speciesPercentages)}
                            onClick={() => toggleWindow('speciesPercentages')}
                        >
                            📈 Species Percentages {speciesPercentages ? '(Open)' : ''}
                        </button>

                        <button
                            style={windowButtonStyle(energyGraph)}
                            onClick={() => toggleWindow('energyGraph')}
                        >
                            📊 Energy Graph {energyGraph ? '(Open)' : ''}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
});

UnifiedStatisticsPanel.displayName = 'UnifiedStatisticsPanel';

export default UnifiedStatisticsPanel;

